/* Conserva il trigger Klaviyo durante i rerender Focal, senza ricreare il popup. */
(() => {
  if (window.extroBISBridgeReady) return;
  window.extroBISBridgeReady = true;
  let trigger = null;
  let queued = false;
  let observer;

  const sync = () => {
    queued = false;
    const scope = document.querySelector('[data-extro-product-hover]');
    const button = scope?.querySelector('[data-product-add-to-cart-button]');
    trigger ||= scope?.querySelector('.klaviyo-bis-trigger');
    if (!button || !trigger) return;
    observer?.disconnect();
    if (trigger.parentElement !== button.parentElement) button.after(trigger);

    // Focal aggiorna l'URL dopo il primo change: Klaviyo legge ora l'ID definitivo.
    const id = button.form?.elements.namedItem('id');
    if (id?.value) id.dispatchEvent(new Event('change', { bubbles: true }));
    const soldOut = !!button.dataset.variantId && button.dataset.variantAvailable === 'false';
    trigger.hidden = !soldOut;
    button.hidden = soldOut && trigger.style.display !== 'none';
  };
  const schedule = () => {
    if (queued) return;
    queued = true;
    queueMicrotask(sync);
  };

  document.addEventListener('variant:change', schedule);
  document.addEventListener('product:rerender', schedule, true);
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('click', event => {
    const clicked = event.target.closest('.klaviyo-bis-trigger');
    if (!clicked || !clicked.closest('[data-extro-product-hover]')) return;
    sync();
    if (clicked.hidden || clicked.closest('[data-extro-variant-pending]')) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  // Osserva solo l'arrivo iniziale del trigger, poi usa gli eventi del tema.
  observer = new MutationObserver(schedule);
  const scope = document.querySelector('[data-extro-product-hover]');
  if (scope) observer.observe(scope, { childList: true, subtree: true });
  sync();
})();
